// extracted by mini-css-extract-plugin
module.exports = {"root":"Widget_root__lEQPW","open":"Widget_open__1WlF5","customTransition":"Widget_customTransition__1vY7O","close":"Widget_close__SAXdy"};